import React, { Component } from "react";
import {
  Modal,
  NavBar,
  Icon,
  Button,
  WingBlank,
  WhiteSpace,
  List,
  Toast,
} from "antd-mobile";
import "./clockinsdk.scss";
import company_sys from "../../../assets/images/saoyisao.png";
import NoneDatas from "../../../components/noneDatas"

const Item = List.Item;
const alert = Modal.alert

function formatWxError(res) {
  if (!res) return "扫码失败";
  if (typeof res === "string") return res;
  return res.errMsg || res.err_msg || "扫码失败";
}

const SCAN_FORMAT_ERROR = "格式不正确";

function isFifteenDigitImei(value) {
  const str = value == null ? "" : String(value).trim();
  return str.length === 15 && /^[0-9]{15}$/.test(str);
}

/** 微信扫码有时会带码制前缀，如 QR_CODE,8601... */
function normalizeScanRaw(resultStr) {
  const raw = String(resultStr).trim();
  const prefixMatch = raw.match(
    /^(QR_CODE|CODE_128|CODE_39|CODE_93|EAN_13|EAN_8|UPC_A|UPC_E|DATA_MATRIX|PDF_417|ITF|CODABAR|AZTEC),([\s\S]+)$/i
  );
  return prefixMatch ? prefixMatch[2].trim() : raw;
}

function parseScanResult(resultStr) {
  if (!resultStr) {
    throw new Error(SCAN_FORMAT_ERROR);
  }
  const raw = normalizeScanRaw(resultStr);
  if (isFifteenDigitImei(raw)) {
    return { imei: raw, type: 1 };
  }
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed) && parsed.imei) {
      return {
        imei: String(parsed.imei),
        type: parsed.type != null ? parsed.type : 1,
      };
    }
    const scannedStr = parsed == null ? "" : String(parsed);
    if (isFifteenDigitImei(scannedStr)) {
      return { imei: scannedStr, type: 1 };
    }
  } catch (e) {
    // 非 JSON，走统一格式错误
  }
  throw new Error(SCAN_FORMAT_ERROR);
}

export class Clockinsdk extends Component {
  state = {
    imeiList: [],
  };
  componentDidMount() {
    console.log('sdk-!')
    const configStr = localStorage.getItem('configData');
    if (!configStr) {
      console.warn('微信扫码配置尚未就绪');
      return;
    }
    const configData = JSON.parse(configStr);
    console.log('cfg', configData);
    window.wx.config(configData);
    window.wx.ready(() => {
      console.log("cfg-初始化完成");
    });
  }
  DYcamera = () => {
    window.wx.scanQRCode({
      needResult: 1,
      desc: "scanQRCode desc",
      success: (res) => {
        console.log('扫描~', res)
        try {
          const result = parseScanResult(res.resultStr);
          console.log('扫描result', result)
          localStorage.setItem('scan:result:imei', JSON.stringify(result));
          this.props.history.push("/Dakatale");
        } catch (e) {
          Toast.fail(e.message || '扫码结果解析失败', 2);
        }
      },
      fail: (res)=> {
        console.log('err!',res)
        Toast.fail(formatWxError(res), 2)
      },
      complete: (res) => {
        console.log('end!',res)
      }
    })
  }; 
  
  DYcamera2 = () => {
    window.wx.scanQRCode({
      needResult: 1,
      desc: "scanQRCode desc",
      success: (res) => {
        console.log('扫描~', res)
        try {
          const parsed = parseScanResult(res.resultStr);
          const isDuplicate = this.state.imeiList.some(
            (item) => item.imei === parsed.imei
          );
          if (isDuplicate) {
            Toast.fail(`IMEI ${parsed.imei} 已存在，请勿重复扫码`, 2);
            return;
          }
          const result = [...this.state.imeiList, parsed];
          console.log('扫描result', result)
          localStorage.setItem('scan:result:imei', JSON.stringify(result));
          localStorage.setItem('scan:result:imeiList', JSON.stringify(result));
          this.setState({ imeiList: result });
        } catch (e) {
          Toast.fail(e.message || '扫码结果解析失败', 2);
        }
      },
      fail: (res)=> {
        console.log('err!',res)
        Toast.fail(formatWxError(res), 2)
      },
      complete: (res) => {
        console.log('end!',res)
      }
    })
  }
  onSave = () => {
    console.log('跳?',this.state.imeiList,this.state.imeiList.length)
    if(this.state.imeiList.length > 0){
      // 跳转到新建页
      // Toast.success('ok!')
      this.props.history.push("/Tdaka")
    }else{
      // 提示无数据时 不跳转
      Toast.fail('暂无数据, 请先扫码')
    }
    
  }
  DYcamera3 = () => {
    // 随机一条数据
    let number = Math.floor(Math.random()*10)
    let randomIMEI = {"imei":"89860230035678"+number,"type":1}

    let random = this.state.imeiList
    random.push(randomIMEI)
    console.log("记录?",this.state.imeiList,'随机数?',number,"?",randomIMEI,"数组?",random)
    
    // 保存传递数据
    localStorage.setItem('scan:result:imeiList', JSON.stringify(random));
    this.setState({
      imeiList: random
    },()=>{})
    
  }

  // 测试跳转成功
  success = () => {
    const result = {"imei":"860181063921271","type":1}
    localStorage.setItem('scan:result:imei', JSON.stringify(result));
    this.props.history.push("/Dakatale");
    console.log('result', result)
  };

  // 删除列表中的imei
  onDelectImei(item,index){
    console.log('!~',item,index)
    const imeidArr = this.state.imeiList.filter((_, i) => i !== index);
    localStorage.setItem('scan:result:imeiList', JSON.stringify(imeidArr));
    localStorage.setItem('scan:result:imei', JSON.stringify(imeidArr));
    this.setState({
      imeiList: imeidArr
    })
  }

  render() {
    const { imeiList } = this.state
    return (
      <div className="kakaing">
        <NavBar mode="dark"
          icon={<Icon type="left" />}
          onLeftClick={() => this.props.history.goBack()}
        >扫码界面</NavBar>
        <div className="saoyisao">
          <WingBlank>
            {/* <h4>请点击扫一扫</h4> */}
            {/* <img src={company_sys} alt="" onClick={this.DYcamera2()} /> */}
            <img src={company_sys} alt=""/>
            {/* <Button type="primary" onClick={() => this.success()}>扫码成功测试跳转</Button> */}
            <WhiteSpace size="xl" />
            <Button type="primary" onClick={() => this.DYcamera2()}>
              开始批量扫码
            </Button>
            <WhiteSpace size="xl" />
            {/* <Button type="primary" onClick={() => this.DYcamera3()}>
              扫码测试
            </Button>
            <WhiteSpace size="xl" /> */}
            <Button type="primary" onClick={() => this.onSave()}>
              创建账号
            </Button>
          </WingBlank>
        </div>
        {/* 批量扫码部分 */}
        <WingBlank>
          <p>扫描到的数据:</p>
          <div style={{maxHeight:'200px',overflow:'auto'}} >
            <List>
              {imeiList.map((item, index) => {
                return (
                  <Item 
                    key={index}
                    extra={
                      <Button 
                        size="small" 
                        type="warning" 
                        inline='true' 
                        onClick={()=> alert('删除', '是否删除该条扫码结果?', [
                          { text: '取消', onPress: () => console.log('cancel') },
                          { text: '确认', onPress: () => this.onDelectImei(item,index) },
                        ])}
                        key={index}
                      >
                      删
                      </Button>
                    }
                  >
                    {item.imei}
                  </Item>
              )})}
              {imeiList.length == 0? <NoneDatas /> : ""}
            </List>
          </div>
        </WingBlank>
      </div>
    );
  }
}

export default Clockinsdk;
